import { render, staticRenderFns } from "./UsersCards.vue?vue&type=template&id=59a8d266&"
import script from "./UsersCards.vue?vue&type=script&lang=js&"
export * from "./UsersCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports